export default __webpack_public_path__ + "c0a5ff335ec82d4dc42d318fc558aa2b.png";